<template>
  <el-select
      style="width: 100%"
      size="mini"
      v-model="currentValue"
      :allow-create="allowCreate"
      :default-first-option="true"
      :filterable="true"
      placeholder="分组名称">
    <el-option
        v-for="item in dataList"
        :key="item"
        :label="item"
        :value="item">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'OrderDetailGroup',
  props: {
    value: {
      type: String,
      default: ''
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dataList: [],
    }
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      },
    },
  },
  watch: {
    orderId: {
      handler: function () {
        this.getDataList()
      },
      immediate: true
    }
  },
  methods: {
    async getDataList () {
      if (!this.orderId) {
        this.dataList = []
        return
      }
      this.dataList = await this.$api2.get(`/erp/order/detail/groups`, { params: { orderId: this.orderId } })
    }
  }
}
</script>

<style scoped>

</style>
